// Division-level fixture prediction insight.
import { httpsCallable } from 'firebase/functions';
import { functions } from '../firebase';

export interface FixtureInsight {
  ok: true;
  fixtureId: string;
  sampleSize: number;
  divisionSize?: number;
  /** Division split on the 1X2 base. */
  outcome?: { HOME: number; DRAW: number; AWAY: number };
  /** The single most-backed boost across the division (display-only). */
  topLeg?: { marketId: string; label: string; pct: number } | null;
}

/** How the caller's division predicted a fixture (anonymised percentages). */
export async function getFixtureInsight(
  leagueId: string,
  roundId: string,
  fixtureId: string
): Promise<FixtureInsight> {
  const call = httpsCallable<{ leagueId: string; roundId: string; fixtureId: string }, FixtureInsight>(
    functions,
    'getFixtureInsight'
  );
  return (await call({ leagueId, roundId, fixtureId })).data;
}
